import './style.scss';

import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { Button } from 'primereact/button';
import CustomFileInput from 'components/FormControl/CustomFileInput';
import { formatFileName } from 'utils/func';

export default function UploadAppendixFiles({
  disabled,
  control,
  errors,
  data,
  appendixeArray,
  handleDownloadFile,
  setAppendixFilesDelete,
  setAppendixeArray,
}) {
  // #region Data
  const { t } = useTranslation();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'appendixFiles',
  });

  // #endregion Data
  return (
    <>
      <h5>{t('contract.form.uploadAppendix')}</h5>
      {fields?.map((item, index) => (
        <div className="relative pl-4" key={item.id}>
          {!disabled && <hr className="border border-1 border-primary my-1" />}
          <span className="font-bold">
            {t('formLayout.appendix')}: {appendixeArray.length + index + 1}
          </span>

          {!disabled && (
            <CustomFileInput
              name={`appendixFiles.${index}`}
              accept=".pdf"
              acceptOnly="pdfOnly"
              acceptFileMessage="Chỉ chấp nhận file pdf"
              defaultNameFile={`${data?.id}-${data?.name}-${appendixeArray.length + index + 1}.pdf`}
              control={control}
              errors={errors}
            />
          )}

          {item?.fileName && (
            <span
              className="p-button p-button-text p-button-sm mt-1 mb-3 p-0"
              onClick={() => handleDownloadFile(item?.fileName)}
            >
              <i className="pi pi-file-pdf text-red-500 text-xl" />{' '}
              <span className="text-blue-500 underline font-italic text-base">
                {formatFileName(item?.fileName)}
              </span>
            </span>
          )}

          {!disabled && (
            <button
              className="p-button p-button-text p-button-icon-only p-0 absolute top-0 right-0 mt-2"
              type="button"
              onClick={() => remove(index)}
              disabled={disabled}
            >
              <i type="button" className="pi pi-times text-red-500 text-xl" />
            </button>
          )}
        </div>
      ))}
      {!disabled && fields?.length < 4 && (
        <div className="pl-4">
          <hr className="border border-1 border-primary mt-1 mb-1" />
          <div className="flex justify-content-center">
            <button
              className="p-button p-button-text p-button-icon-only p-0"
              type="button"
              onClick={() => {
                append({
                  id: uuidv4(),
                  file: null,
                });
              }}
              disabled={disabled}
            >
              <i type="button" className="pi pi-fw pi-plus text-primary text-xl" />
            </button>
          </div>
        </div>
      )}
      <div className="file-appendix-table">
        {appendixeArray?.length > 0 && <div>{t('component.attachedFiles')}:</div>}
        {appendixeArray?.map((appendixe) => (
          <div
            key={appendixe.id}
            className="mt-2 flex justify-content-between align-content-center"
          >
            <span
              key={appendixe?.fileUrl}
              className="py-2"
              style={{ minWidth: '16rem', cursor: 'pointer' }}
              onClick={() => handleDownloadFile(appendixe?.fileUrl)}
            >
              <i className="pi pi-file-pdf text-xl mr-2" style={{ color: 'red' }} />
              <span className="text-blue-500 underline font-italic text-base">
                {formatFileName(appendixe?.fileUrl)}
              </span>
            </span>
            <Button
              className="py-2"
              icon="pi pi-times"
              rounded
              text
              severity="danger"
              aria-label="Cancel"
              type="button"
              onClick={() => {
                setAppendixFilesDelete((prev) => [...prev, appendixe?.id]);
                setAppendixeArray((prev) => prev.filter((item) => item?.id !== appendixe?.id));
              }}
              disabled={disabled}
            />
            <span className="py-4 flex-auto" />
          </div>
        ))}
      </div>
    </>
  );
}

UploadAppendixFiles.propTypes = {
  disabled: PropTypes.bool,
  errors: PropTypes.shape({}).isRequired,
  control: PropTypes.shape({}).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  appendixeArray: PropTypes.array.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object,
  handleDownloadFile: PropTypes.func,
  setAppendixFilesDelete: PropTypes.func,
  setAppendixeArray: PropTypes.func.isRequired,
};

UploadAppendixFiles.defaultProps = {
  disabled: false,
  data: {},
  handleDownloadFile: () => null,
  setAppendixFilesDelete: () => null,
};
